<nav class="relative flex  px-2 h-16  shadow-md">
    <div class="w-full px-4 flex items-center justify-between">
        <div class="flex items-center font-bold text-xl">
            <ng-container *ngxPermissionsOnly="['ADMIN', 'ACCOUNTANT', 'STORE', 'SALE_1', 'SALE_2', 'NUTRISHOP_1']">
                <button class="text-base whitespace-nowrap me-2" mat-icon-button aria-label="menu"
                    (click)="toggleSidenav()">
                    <mat-icon class="text-black">
                        {{isOpen ? 'format_align_left' : 'menu'}}
                    </mat-icon>
                </button>
            </ng-container>

            <!-- Home của người dùng cần hiển thị là "Khách hàng" hoặc "NV PTTT" hoặc "Nutriday Shop" -->
            <ng-template ngxPermissionsOnly="ADMIN">
                Quản trị hệ thống
            </ng-template>
            <ng-template ngxPermissionsOnly="ID_USER">
                Khách hàng
            </ng-template>
            <ng-template ngxPermissionsOnly="ACCOUNTANT">
                NV PTTT
            </ng-template>
            <ng-template ngxPermissionsOnly="NUTRI_SHOP">
                Nutriday Shop
            </ng-template>
            <ng-template ngxPermissionsOnly="STORE">
                STORE
            </ng-template>
            <ng-template ngxPermissionsOnly="NUTRISHOP_1">
                NUTRISHOP_1
            </ng-template>
        </div>
        <div class="flex">
            <ng-template [ngxPermissionsExcept]="['ADMIN', 'ACCOUNTANT', 'STORE', 'SALE_1', 'SALE_2','NUTRISHOP_1']">
                <div class="flex flex-grow justify-end items-center xl:me-5 xl:pe-4">
                    <div class="grid grid-cols-6 gap-1">
                        <div class="bg-linear-gradient rounded-lg p-1 col-span-1">
                            <div class="text-xs">Danh hiệu</div>
                            <div class="text-xl">{{mapLevel[statistics?.level]}}</div>
                        </div>
                        <div class="bg-linear-gradient rounded-lg p-1  col-span-1">
                            <div class="text-xs">Huy hiệu</div>
                            <div class="text-xl">{{statistics?.badge}}</div>
                        </div>
                        <div class="bg-linear-gradient rounded-lg p-1 col-span-1 ">
                            <div class="text-xs">Doanh số cá nhân</div>
                            <div class=" text-xl">
                                {{(statistics?.personalAmount ? statistics?.personalAmount:0) |currency:"VND":""}}
                            </div>
                        </div>
                        <div class="bg-linear-gradient rounded-lg p-1 col-span-1 ">
                            <div class="text-xs">Danh số quản lý trực tiếp</div>
                            <div class=" text-xl">
                                {{(statistics?.directAmount? statistics?.directAmount:0) |currency:"VND":""}}
                            </div>
                        </div>
                        <div class="bg-linear-gradient rounded-lg p-1 col-span-1">
                            <div class="text-xs">Số lon tích lũy</div>
                            <div class=" text-xl">
                                {{(statistics?.totalPoint? statistics?.totalPoint:0) |currency:"VND":""}}
                            </div>
                        </div>
                        <div class="bg-linear-gradient rounded-lg p-1 col-span-1 ">
                            <div class="text-xs">Thưởng chức danh</div>
                            <div class=" text-xl">
                                {{(statistics?.bonusAmount?statistics?.bonusAmount:0) |currency:"VND":""}}
                            </div>
                        </div>
                    </div>
                    <button mat-button class="text-base whitespace-nowrap cart" (click)="onOpenModal()">
                        <mat-icon>shopping_cart</mat-icon>
                        <div class="admin-text">Giỏ hàng</div>
                    </button>
                </div>
            </ng-template>

            <ng-template ngxPermissionsOnly="ADMIN">
                <button class="text-base whitespace-nowrap notifications_none" mat-icon-button
                    (menuOpened)="onShowNotifications()" (menuClosed)="isOpenMenuNotifications = false"
                    [matMenuTriggerFor]="beforeMenu">
                    <mat-icon class="whitespace-nowrap icon-notifications" matBadge="!"
                        [matBadgeHidden]="!isNotification" matBadgeColor="primary">notifications_none</mat-icon>
                </button>
                <mat-menu #beforeMenu="matMenu" class="whitespace-nowrap notifications_text" xPosition="before">
                    <ng-container *ngFor="let item of listNotifications">
                        <div mat-menu-item>
                            <span style="font-weight: 500;">{{item.createdDate | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                            {{": "+item.text}}
                        </div>
                    </ng-container>
                </mat-menu>
            </ng-template>

            <div class="flex flex-grow justify-end items-center xl:me-5 xl:pe-4" id="example-navbar-warning">
                <div class="">
                    <img *ngIf="!imgAvatar" src="assets/images/logo.jpg" alt="" class="imageConfig rounded-full">
                    <img *ngIf="imgAvatar" [src]="imgAvatar| image" alt="" class="imageConfig rounded-full">
                </div>
                <div class="flex  person px-1 py-2" [matMenuTriggerFor]="afterMenu">
                    <div class="admin-text ms-3">{{username}}</div>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
            </div>
            <mat-menu #afterMenu="matMenu" class="whitespace-nowrap" xPosition="after">
                <button class="text-base whitespace-nowrap" mat-menu-item (click)="openUserInfo()">Thông tin</button>
                <button class="text-base whitespace-nowrap" mat-menu-item (click)="onOpenChangePass()">
                    Đổi mật khẩu
                </button>
                <button class="text-base whitespace-nowrap" mat-menu-item (click)="logout()">Đăng xuất</button>
            </mat-menu>
        </div>
    </div>
</nav>

<ng-template [ngxPermissionsExcept]="['ADMIN', 'ACCOUNTANT', 'STORE', 'SALE_1', 'SALE_2','NUTRISHOP_1']">
    <mat-toolbar class="bg-cyan-200 h-20">
        <mat-nav-list
            class="navbar grid grid-cols-4 2xl:grid-cols-8 xl:grid-cols-8 lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-4 gap-4 items-center">
            <ng-container *ngFor="let menu of Menu_User">
                <ng-container *ngIf="!menu.children, else childMenu">
                    <button mat-menu-item [routerLink]="[menu.link]"
                        style="justify-content: center; font-size: 1.5rem;">
                        <!-- <span>{{ menu.name }}</span> -->
                        {{ menu.name }}
                    </button>
                </ng-container>
                <ng-template #childMenu>
                    <mat-list-item [matMenuTriggerFor]="menuMenu">
                        <button mat-menu-item style="justify-content: center;">
                            <!-- <span>{{ menu.name }}</span> -->
                            {{ menu.name }}
                        </button>
                    </mat-list-item>
                    <mat-menu #menuMenu="matMenu" [overlapTrigger]="false">
                        <ng-container *ngFor="let subMenu of menu.children">
                            <button mat-menu-item [routerLink]="[subMenu.link]"
                                style="padding-left: 0.5rem !important;padding-right: 0.5rem !important">
                                <!-- <span>{{ subMenu.name }}</span> -->
                                {{ subMenu.name }}
                            </button>
                        </ng-container>
                    </mat-menu>
                </ng-template>
            </ng-container>
        </mat-nav-list>
    </mat-toolbar>
</ng-template>